// Built-ins
import { useState } from "react";

// Icons / Images
import { FiEdit2 } from "react-icons/fi";
import { BsInfoSquare } from "react-icons/bs";

// Modules / Functions
import { Modal, Col, Form, Row } from "react-bootstrap";
import axios from "axios";
import { Button } from "semantic-ui-react";
import Swal from "sweetalert2";

// Global Variables
import { headers } from "../../../../global_vars";

window.Swal = Swal;

const CHANGE_BOOKING_RATING =
  "https://groupplan.gr/api/data_management/change_booking_rating/";

function ChangeBookingRating(props) {
  const [show, setShow] = useState(false);
  const [bookingRating, setBookingRating] = useState("");
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const updateBookingRating = () => {
    axios({
      method: "post",
      url: CHANGE_BOOKING_RATING,
      headers: headers,
      data: {
        object_id: props.object_id,
        object_type: props.object_type,
        booking_rating: bookingRating,
      },
    })
      .then((res) => {
        props.update_state(res.data.object);
      })
      .catch((e) => {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: e.response.data.errormsg,
        });
      });
  };

  const handleChange = (e) => {
    let value = e.target.value;
    if (value === "") {
      setBookingRating("");
      return;
    }
    value = parseFloat(value);
    if (isNaN(value) || value < 0) {
      value = 0;
    } else if (value > 10) {
      value = 10;
    }
    setBookingRating(value.toString());
  };

  return (
    <>
      <FiEdit2
        title={"edit booking rating"}
        id={"edit_hotel_booking_rating"}
        onClick={() => {
          handleShow();
          setBookingRating(
            props.booking_rating !== null && props.booking_rating !== undefined
              ? props.booking_rating
              : ""
          );
        }}
        className={"edit_icon"}
      />
      <Modal
        show={show}
        onHide={handleClose}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>
            Change Booking rating for {props.object_name}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group as={Row} className="mb-3">
            <Form.Label column sm="3">
              Booking rating:
            </Form.Label>
            <Col sm="9" style={{ marginTop: 10 }}>
              <Form.Control
                type="number"
                value={bookingRating}
                style={{ width: 300 }}
                onChange={handleChange}
                max={10}
                min={0}
                step={0.1}
                placeholder="e.g. 8.5"
              />
            </Col>
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <small className="mr-auto">
            <BsInfoSquare
              style={{
                color: "#F3702D",
                fontSize: "1.5em",
                marginRight: "0.5em",
              }}
            />
            Booking.com style rating from 0 to 10. Leave empty to clear.
          </small>
          <Button color="red" onClick={handleClose}>
            Close
          </Button>
          <Button
            color="green"
            onClick={() => {
              handleClose();
              updateBookingRating();
            }}
          >
            Save Changes
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default ChangeBookingRating;
